export default "__VITE_ASSET__CJ1Gn1HT__"